import React from 'react';
import { AlertCircle, CheckCircle2, Euro, Loader2 } from '../../../../shared/assets/AppIcons';
import CompletedDealCard from './CompletedDealCard';

const CompletedSettlementColumn = ({
  title,
  description,
  emptyMessage,
  deals,
  onCardClick,
  onOpenClient,
  onOpenStaff,
  staff = [],
  variant = 'toSettle',
}) => {
  const isUnavailable = variant === 'unavailable';
  const isLoading = isUnavailable && title === 'Verifica settlement';

  return (
    <section className="deals-column">
      <div className="deals-column__header">
        <h3 className="deals-column__title">{title}</h3>
        <div className="deals-column__count">
          {isUnavailable ? (
            isLoading ? (
              <Loader2 size={16} className="animate-spin" aria-hidden="true" />
            ) : (
              <AlertCircle size={16} aria-hidden="true" />
            )
          ) : (
            <Euro size={16} aria-hidden="true" />
          )}
          <span>{description}</span>
        </div>
      </div>

      <div className="deals-column__body">
        {deals.map((deal) => (
          <CompletedDealCard
            key={deal.id}
            deal={deal}
            onClick={onCardClick}
            onOpenClient={onOpenClient}
            onOpenStaff={onOpenStaff}
            staff={staff}
            variant={variant}
          />
        ))}

        {deals.length === 0 && (
          <div className="deals-column__empty">
            <CheckCircle2 size={32} aria-hidden="true" />
            <span>{emptyMessage}</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default CompletedSettlementColumn;
